var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Dashboard White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Dashboard-White"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_dashboard_white_24px-copy"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 50 0 50 50 0 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25,27.0833333 L22.9166667,27.0833333 L22.9166667,6.25 L6.25,6.25 L6.25,27.0833333 Z M6.25,43.75 L22.9166667,43.75 L22.9166667,31.25 L6.25,31.25 L6.25,43.75 Z M27.0833333,43.75 L43.75,43.75 L43.75,22.9166667 L27.0833333,22.9166667 L27.0833333,43.75 Z M27.0833333,6.25 L27.0833333,18.75 L43.75,18.75 L43.75,6.25 L27.0833333,6.25 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWhite);
export default __webpack_public_path__ + "static/media/dashboard-white.10422a33b3624d6ca156e57a2da943a1.svg";
export { ForwardRef as ReactComponent };